import {SET_UPSALE_POPUP_OPEN} from "../actions/UpsaleActions";

const initialState = {
    popupOpen: false,
};

export default function UpsaleReducer(state = initialState, action) {
    switch (action.type) {
        case SET_UPSALE_POPUP_OPEN:
            return { ...state, popupOpen: action.payload };
        default:
            return state;
    }
}
